import { ApiType } from "@gymflow/common";
import { QueryKey } from "@tanstack/react-query";

export const appointmentAsMemberQueryKeys = {
  all: () => ["appointmentAsMember"] as QueryKey,
  id: (id: number) =>
    [...appointmentAsMemberQueryKeys.all(), "id", { id }] as QueryKey,
  summary: (parameters: Readonly<{ [k: string]: any }>) =>
    [
      ...appointmentAsMemberQueryKeys.all(),
      "summary",
      { parameters },
    ] as QueryKey,
  summaryNew: (parameters: Readonly<{ [k: string]: any }>) =>
    [
      ...appointmentAsMemberQueryKeys.all(),
      "summaryNew",
      { parameters },
    ] as QueryKey,
  appointmentUpcoming: (
    filters: Readonly<
      Parameters<
        ApiType["customerAppointmentApi"]["appointmentUpcoming"]
      >[0]["filters"]
    >,
  ) =>
    [
      ...appointmentAsMemberQueryKeys.all(),
      "appointmentUpcoming",
      { filters },
    ] as QueryKey,
  appointmentPast: (
    filters: Readonly<
      Parameters<
        ApiType["customerAppointmentApi"]["appointmentPast"]
      >[0]["filters"]
    >,
  ) =>
    [
      ...appointmentAsMemberQueryKeys.all(),
      "appointmentPast",
      { filters },
    ] as QueryKey,
};
